import * as React from "react";
import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import {
  RiLoader4Fill,
  RiCircleLine,
  RiCheckboxCircleFill,
  RiArrowLeftLine,
  RiArrowRightLine,
  RiFileEditLine,
  RiCalculatorLine,
  RiCheckLine,
} from "react-icons/ri";

import Textfield from "../../Components/Textfield";
import Button from "../../Components/Button";
import Checkbox from "../../Components/Checkbox";
import Dropzone from "../../Components/Dropzone";
import Select from "../../Components/Select";

import TopBarNotConnected from "../../Components/TopBarNotConnected";

import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import Logo from "./../../Images/logo_white.png";
import bgSidebarRight from "./../../Images/bg_sidebar_right.png";
import bgSidebarMobilier from "./../../Images/bg_sidebar_mobilier.png";
import bgSidebarImmobilier from "./../../Images/bg_sidebar_immobilier.png";

import "./FinancingRequestNotConnected.scss";

const initialFormState = {
  declaration_recap: false,
  // Compnay Intial Form
  company_name: "",
  matricule_fiscale: "",
  company_date: "",
  secteur_activity: "",
  company_phone: "",
  company_portable: "",
  company_address: "",
  company_ville: "",
  company_cp: "",

  // Infos perso Intial Form
  first_name: "",
  last_name: "",
  cin: "",
  date: "",
  post: "",
  mail: "",
  phone: "",
  portable: "",
  address: "",
  ville: "",
  code_postal: "",

  // financial Intial Form
  chiffre_affaire: "",
  resultat_net: "",
  capitaux_propres: "",
  endettement_total: "",
  banque_principale: "",
  reference_bancaire: "",

  // document Intial Form
  bilan_comptes: [],
  prevision_financiere: [],
  extrait_kbis: [],
  piece_legal: [],
  releves_comptes: [],
  facture_fournisseur: [],
};

const FinancingRequestRecapNotConnected = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const [stepFinancingRequest, setStepFinancingRequest] = React.useState(1);

  const scrollToRef = React.useRef(null);

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (val, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();
    formData.append("company_name", valRegister.company_name);
    formData.append("matricule_fiscale", valRegister.matricule_fiscale);
    formData.append("company_date", valRegister.company_date);
    formData.append("secteur_activity", valRegister.secteur_activity);
    formData.append("company_phone", valRegister.company_phone);
    formData.append("company_portable", valRegister.company_portable);
    formData.append("company_address", valRegister.company_address);
    formData.append("company_ville", valRegister.company_ville);
    formData.append("company_cp", valRegister.company_cp);

    formData.append("first_name", valRegister.first_name);
    formData.append("last_name", valRegister.last_name);
    formData.append("cin", valRegister.cin);
    formData.append("date", valRegister.date);
    formData.append("post", valRegister.post);
    formData.append("mail", valRegister.mail);
    formData.append("phone", valRegister.phone);
    formData.append("portable", valRegister.portable);
    formData.append("address", valRegister.address);
    formData.append("ville", valRegister.ville);
    formData.append("code_postal", valRegister.code_postal);

    formData.append("chiffre_affaire", valRegister.chiffre_affaire);
    formData.append("resultat_net", valRegister.resultat_net);
    formData.append("capitaux_propres", valRegister.capitaux_propres);
    formData.append("endettement_total", valRegister.endettement_total);
    formData.append("banque_principale", valRegister.banque_principale);
    formData.append("reference_bancaire", valRegister.reference_bancaire);

    formData.append("bilan_comptes", valRegister.bilan_comptes[0] || []);
    formData.append(
      "prevision_financiere",
      valRegister.prevision_financiere[0] || []
    );
    formData.append("extrait_kbis", valRegister.extrait_kbis[0] || []);
    formData.append("piece_legal", valRegister.piece_legal[0] || []);
    formData.append("releves_comptes", valRegister.releves_comptes[0] || []);
    formData.append(
      "facture_fournisseur",
      valRegister.facture_fournisseur[0] || []
    );

    axios
      .post(`${process.env.REACT_APP_API_URL}/financing-request`, formData)
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const propertyType = "Mobilier";

  return (
    <div className="layout-app layout-not-connected ">
      <div className="sideBar sideBar-not-connected">
        <Link to="/" className="logo logo-white">
          <img
            src={Logo}
            alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
          />
        </Link>
        <div className="title-sidebar-not-connected active">
          Lancez votre projet Leasing
        </div>
        <div className="menu-sidebar-not-connected">
          <RiCalculatorLine /> Simulations
        </div>
        <div className="menu-sidebar-not-connected active">
          <RiFileEditLine /> Demande de Financement
        </div>
      </div>
      <div className="wrap-app wrap-app-not-connected">
        <TopBarNotConnected
          colWidth={12}
          title="Récupulatif"
          description="Revoyez toutes les informations fournies dans ce formulaire pour vous assurer de leur exactitude et de leur exhaustivité."
        />
        <div className="" ref={scrollToRef}></div>

        <div className="container-app container-app-not-connected">
          <div className="wrap-steps-sidebar-not-connected">
            <div className={`steps-sidebar-not-connected visited`}>
              1. Entreprise
              <RiCheckLine />
            </div>
            <div className={`steps-sidebar-not-connected visited`}>
              2. Représentant Légal
              <RiCheckLine />
            </div>
            <div className={`steps-sidebar-not-connected visited`}>
              3. Informations Financières
              <RiCheckLine />
            </div>
            <div className={`steps-sidebar-not-connected visited`}>
              4. Documents à Joindre
              <RiCheckLine />
            </div>
            <div className={`steps-sidebar-not-connected active`}>
              5. Récapitulatif
            </div>
          </div>
          <Row>
            <Col md={8}>
              <div className="wrap-financing-request">
                <form
                  className="financing-request"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <div className="step-financing-request custom-accordion mb-16">
                    <Accordion defaultActiveKey="0" alwaysOpen>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          Détails du Projet de Leasing
                        </Accordion.Header>
                        <Accordion.Body>
                          <table className="table custom-table">
                            <tbody>
                              <tr>
                                <td>Montant</td>
                                <td>5. 000 TND</td>
                              </tr>
                              <tr>
                                <td>Durée</td>
                                <td className="orange">15 mois</td>
                              </tr>
                              <tr>
                                <td>Taux</td>
                                <td>15 %</td>
                              </tr>
                              <tr>
                                <td>Marque</td>
                                <td>Audi</td>
                              </tr>
                              <tr>
                                <td>Type de bien à financer</td>
                                <td>Mobilier</td>
                              </tr>
                              <tr>
                                <td>Fournisseur</td>
                                <td>Ennakl</td>
                              </tr>
                              <tr>
                                <td>Description</td>
                                <td>Véhicule utilitaire pour livraisons</td>
                              </tr>

                              <tr>
                                <td colSpan={2} className="last-child-table">
                                  <div className="titlte-montant">
                                    Montant du loyer par mois
                                  </div>
                                  <div className="value-montant">
                                    380.000 TND
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="1">
                        <Accordion.Header>
                          Informations sur le Demandeur
                        </Accordion.Header>
                        <Accordion.Body>
                          <table className="table custom-table">
                            <tbody>
                              <tr>
                                <td>Nom</td>
                                <td>Medianet</td>
                              </tr>
                              <tr>
                                <td>Matricule fiscal</td>
                                <td>XXXXXXXXXX</td>
                              </tr>
                              <tr>
                                <td>Date de création</td>
                                <td>01/01/1999</td>
                              </tr>
                              <tr>
                                <td>Secteur d'Activité</td>
                                <td>Informatique</td>
                              </tr>
                              <tr>
                                <td>Email de l'Entreprise</td>
                                <td>Support@medianet.com.tn</td>
                              </tr>
                              <tr>
                                <td>Téléphone</td>
                                <td>71 717 171</td>
                              </tr>
                              <tr>
                                <td>Portable</td>
                                <td>55 555 555</td>
                              </tr>
                              <tr>
                                <td>Adresse</td>
                                <td>
                                  Résidence El Manar, Bloc C, Appartement 5,
                                  <br />
                                  Avenue Habib Bourguiba , 1000 Tunis, Tunisie
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="2">
                        <Accordion.Header>
                          Informations sur le Représentant Légal
                        </Accordion.Header>
                        <Accordion.Body>
                          <table className="table custom-table">
                            <tbody>
                              <tr>
                                <td>Nom et Prénom</td>
                                <td>Tarek MESLAMENI</td>
                              </tr>
                              <tr>
                                <td>Date de naissance</td>
                                <td>1/1/1999</td>
                              </tr>
                              <tr>
                                <td>Poste</td>
                                <td>Directeur</td>
                              </tr>
                              <tr>
                                <td>Tel</td>
                                <td>123456789</td>
                              </tr>
                              <tr>
                                <td>Tel portable</td>
                                <td>123456789</td>
                              </tr>
                              <tr>
                                <td>Email</td>
                                <td>tarek.meslameni@medianet.com</td>
                              </tr>
                              <tr>
                                <td>Adresse</td>
                                <td>
                                  Résidence El Manar, Bloc C, Appartement 5,
                                  <br />
                                  Avenue Habib Bourguiba , 1000 Tunis, Tunisie
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="3">
                        <Accordion.Header>
                          Informations Financières
                        </Accordion.Header>
                        <Accordion.Body>
                          <table className="table custom-table">
                            <tbody>
                              <tr>
                                <td>Chiffre d'Affaires Annuel</td>
                                <td>50 5555 555</td>
                              </tr>
                              <tr>
                                <td>Résultat Net Annuel</td>
                                <td>25 00252</td>
                              </tr>
                              <tr>
                                <td>Capitaux Propres</td>
                                <td>54656 54654</td>
                              </tr>
                              <tr>
                                <td>Endettement Total</td>
                                <td>20%</td>
                              </tr>
                              <tr>
                                <td>Banque Principale</td>
                                <td>Attajari Bank</td>
                              </tr>
                              <tr>
                                <td>Références Bancaires</td>
                                <td>1564 56465 45654 54641</td>
                              </tr>
                            </tbody>
                          </table>
                        </Accordion.Body>
                      </Accordion.Item>

                      <Accordion.Item eventKey="4">
                        <Accordion.Header>Documents à Joindre</Accordion.Header>
                        <Accordion.Body>
                          <ul className="list-accordion">
                            <li>
                              Bilans et Comptes de Résultat des 3 Dernières
                              Années.pdf
                            </li>
                            <li>Prévisions Financières.pdf</li>
                            <li>Extrait Kbis de Moins de 3 Mois.pdf</li>
                            <li>Pièce d'Identité du Représentant Légal.pdf</li>
                            <li>
                              Relevés de Compte Bancaire des 6 Derniers Mois.pdf
                            </li>
                            <li>Devis ou Facture Proforma du FournisseurPDF</li>
                          </ul>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                    <h2 className="title_form mt-40">Déclaration</h2>
                    <Checkbox
                      label="Je soussigné(e) Tarek MESLAMENI, représentant légal de Medianet, certifie que les informations fournies dans ce formulaire sont exactes et complètes.
Je m'engage à informer immédiatement l'institution financière de toute modification concernant les informations fournies."
                      id="declaration_recap"
                      name="declaration_recap"
                      value="declaration_recap"
                      onChange={(e) =>
                        handleChangeField(e.target.checked, "declaration_recap")
                      }
                      // checked={
                      //   valRegister.declaration_recap === "declaration_recap"
                      // }
                    />
                  </div>

                  <div className="wrap-btn-action-request">
                    <Button variant="white">
                      <Link to="/financing-request" className="black">
                        <RiArrowLeftLine />
                        Précedent
                      </Link>
                    </Button>
                    <Button
                      type="submit"
                      disabled={!valRegister.declaration_recap}
                    >
                      Soumettre la Demande
                    </Button>
                  </div>
                </form>
              </div>
            </Col>
            <Col md={4}>
              <div className="wrap-sidebar-right">
                <div className="header-sidebar-right-notConnected">
                  <img
                    src={
                      propertyType === "Immobilier"
                        ? bgSidebarImmobilier
                        : propertyType === "Mobilier"
                        ? bgSidebarMobilier
                        : bgSidebarRight
                    }
                    alt=""
                    style={{ maxWidth: "100%", width: "100%" }}
                  />
                </div>
                <div className="content-sidebar-right-notConnected">
                  <div className="title-content-sidebar-right">
                    Résultat de la simulation
                  </div>
                  <div className="box-content-sidebar-right">
                    <div className="subtitle-content-sidebar-right">
                      Montant du loyer par mois
                    </div>
                    <div className="txt-content-sidebar-right price-sidebar">
                      1236.35 TND
                    </div>
                  </div>
                  <div className="box-content-sidebar-right">
                    <div className="subtitle-content-sidebar-right">
                      Type de bien à financer
                    </div>
                    <div className="txt-content-sidebar-right">Mobilier</div>
                  </div>
                  <div className="box-content-sidebar-right">
                    <div className="subtitle-content-sidebar-right">
                      Montant
                    </div>
                    <div className="txt-content-sidebar-right">45000 Dt</div>
                  </div>
                  <div className="box-content-sidebar-right">
                    <div className="subtitle-content-sidebar-right">Durée</div>
                    <div className="txt-content-sidebar-right">36 Mois</div>
                  </div>
                </div>
                <div className="footer-sidebar-right-notConnected">
                  Assurez-vous de remplir chaque champ avec précision pour
                  éviter tout retard dans le traitement de votre demande.
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default FinancingRequestRecapNotConnected;
